// extracted by mini-css-extract-plugin
export default {"errorInput":"styles_errorInput__qOdyy","titleLabel":"styles_titleLabel__t0ptI","uploadButtonContainer":"styles_uploadButtonContainer__pVYLz"};